/*
function addedToWishlist(productHandle) {
  fetch('/products/' + productHandle + '.js')
    .then(function(res) { return res.json(); })
    .then(function(product) {
      var _learnq = _learnq || [];
      
      var featuredImage = '';
      if (product.featured_image) {
        featuredImage = 'https:' + product.featured_image;
      } else if (product.images && product.images.length > 0) {
        featuredImage = 'https:' + product.images[0];
      }

      _learnq.push(['track', 'Added to Wishlist', {
        product_id: product.id,
        product_name: product.title,
        product_handle: product.handle,
        product_url: window.location.origin + '/products/' + product.handle,
        product_image_url: featuredImage,
        product_price: product.price / 100
      }]);

      _learnq.push(['identify', {
        'Wishlisted Product Name': product.title,
        'Wishlisted Product URL': window.location.origin + '/products/' + product.handle,
        'Wishlisted Product Image': featuredImage,
        'Wishlisted Product Price': product.price / 100
      }]);
    })
    .catch(function(err) {
      console.error('[Wishlist Klaviyo] Failed to fetch product data:', err);
    });
}
*/

function addedToWishlist(productHandle) {
  fetch('/products/' + productHandle + '.js')
    .then(function (res) { return res.json(); })
    .then(function (product) {
      var featuredImage = '';
      if (product.featured_image) {
        featuredImage = 'https:' + product.featured_image;
      } else if (product.images && product.images.length > 0) {
        featuredImage = 'https:' + product.images[0];
      }

      // Records the custom "Added to Wishlist" metric (the event your flow triggers on).
      klaviyo.push(['track', 'Added to Wishlist', {
        product_id: product.id,
        product_name: product.title,
        product_handle: product.handle,
        product_url: window.location.origin + '/products/' + product.handle,
        product_image_url: featuredImage,
        product_price: product.price / 100
      }]);

      // Optional. identify requires an email (or phone_number), so only fire it when you
      // know the shopper. Replace window.customerEmail with the logged-in customer's email.
      if (window.customerEmail) {
        klaviyo.push(['identify', {
          email: window.customerEmail,
          'Wishlisted Product Name': product.title,
          'Wishlisted Product URL': window.location.origin + '/products/' + product.handle,
          'Wishlisted Product Image': featuredImage,
          'Wishlisted Product Price': product.price / 100
        }]);
      }

      console.log('wishlist klaviyo.');
    })
    .catch(function (err) {
      console.error('[Wishlist Klaviyo] Failed to fetch product data:', err);
    });
}






function callmetoset() {
  setTimeout(function () {
    var wishlist = getWishlist();

    if (wishlist.length > 0) {
      $(".wishbtnheader .wishlistcount").html(wishlist.length);
      $(".wishbtnheader .wishlistcount").addClass("active");
    }

    if (!wishlist.length) {
      $(".wishbtnheader .wishlistcount").html("");
      $(".wishbtnheader .wishlistcount").removeClass("active");
    }

    var grid = document.querySelector(selectors.grid) || false;
    if (grid) setupGrid(grid);

    var buttons = document.querySelectorAll(selectors.button) || [];
    if (buttons.length) setupButtons(buttons);
  }, 100);
}

function onclickfunc(productHandle, selector) {
  
  if (!window.customerLoggedIn) {

  // Save handle temporarily before redirecting
  localStorage.setItem("wishlistAfterLogin", productHandle);
 
  showLoginPopup();
  return; // stop wishlist action
  }
 
  updateWishlist(productHandle);
  selector.classList.toggle(BUTTON_ACTIVE_CLASS);

  // ✅ Fire Klaviyo event only when adding (not removing)
  if (selector.classList.contains(BUTTON_ACTIVE_CLASS)) {
    addedToWishlist(productHandle);
  }

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);

  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
}

var LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
var LOCAL_STORAGE_DELIMITER = ",";
var BUTTON_ACTIVE_CLASS = "active";

var selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
};


var setupGrid = function (grid) {
  var wishlist = getWishlist();

  if (!wishlist.length) {
    grid.innerHTML = EmptyString;
  
    if(document.querySelector('#shareWishlistBtn'))
      document.querySelector('#shareWishlistBtn').classList.add('hidden');
  
    return;
  }

  if(document.querySelector('#shareWishlistBtn'))
    document.querySelector('#shareWishlistBtn').classList.remove('hidden');

  if (wishlist.map) {
    var requests = wishlist.map(function (handle) {
      var productTileTemplateUrl = "/products/" + handle + "?view=card";
      return fetch(productTileTemplateUrl).then(function (res) {
        return res.text();
      });
    });
    Promise.all(requests).then(function (responses) {
      var wishlistProductCards = responses.join("");
      grid.innerHTML = wishlistProductCards;
      var buttons = grid.querySelectorAll(selectors.button) || [];
      if (buttons.length) setupButtons(buttons);
    });
  }
};

var setupButtons = function (buttons) {
  if (buttons) {
    buttons.forEach(function (button) {
      var productHandle = button.dataset.productHandle || false;
      if (!productHandle)
        return console.error(
          "[Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
        );
      if (wishlistContains(productHandle))
        button.classList.add(BUTTON_ACTIVE_CLASS);
      else button.classList.remove(BUTTON_ACTIVE_CLASS);
    });
  }
};

 

/*
var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);

  if (document.querySelector(selectors.grid)) {
    document.querySelector(selectors.grid).innerHTML = EmptyString;
    return false;
  } else {
    return [];
  }
};
*/

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
 
 // When no wishlist exists
  if (!wishlist) { 
    return []; // Always return an array for safety
  }

  var items = wishlist.split(LOCAL_STORAGE_DELIMITER).filter(Boolean);
  return Array.isArray(items) ? items : [];
};


var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) {
    localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  }
  return wishlist;
};




var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) {
    wishlist.push(handle);
  } else {
    wishlist.splice(indexInWishlist, 1);
  }
  callmetoset();
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};


 

document.addEventListener("DOMContentLoaded", function () {
 

  if (!window.customerLoggedIn) {   
    if(window.location.pathname == "/pages/wishlist"){
      var gridi = document.querySelector("section#wishlist");
      if(gridi){
        gridi.classList.add('nocustomer');
      }
    }else{  
    return; // stop wishlist action
    }
  }


  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
 
 
  //  callmetoset();

  const paramstoadd = new URLSearchParams(window.location.search);
  const handlesvalues = paramstoadd.getAll("handle"); 
  if (handlesvalues.length) {
    // Merge with existing wishlist
    const existing = getWishlist() || [];
    const combined = Array.from(new Set([...existing, ...handlesvalues]));
    setWishlist(combined);

    console.log("Added to wishlist:", combined);
  } 

  if (window.customerLoggedIn) {
  const storedHandle = localStorage.getItem("wishlistAfterLogin"); 
  if (storedHandle) {
    // Add it to the wishlist
    const wishlist = getWishlist() || [];
    if (!wishlist.includes(storedHandle)) {
      wishlist.push(storedHandle);
      setWishlist(wishlist);
      console.log("Added saved handle to wishlist:", storedHandle);
    } 
    // Clear it after adding
    localStorage.removeItem("wishlistAfterLogin");  
  } 
  }

  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);

  callmetoset(); 
  setTimeout(function () {
  callmetoset();
  }, 2000);

 
});



// Share Wishlist Popup Script
const shareBtn = document.getElementById("shareWishlistBtn");
const popup = document.getElementById("wishlistPopup");
const closeBtn = document.getElementById("closeWishlistBtn");
const copyBtn = document.getElementById("copyWishlistBtn");
const copyBtn2 = document.getElementById("copyWishlistBtn2");
const linksBox = document.getElementById("wishlistLinks");

if(shareBtn){
shareBtn.addEventListener("click", () => {
  const handles = getWishlist();
  if (!handles || !handles.length) {
    alert("Your wishlist is empty!");
    return;
  }

  const base = "https://cainte.com/pages/wishlist";
  const params = handles.map(h => "handle=" + encodeURIComponent(h)).join("&");
  const link = `${base}?${params}`;

  linksBox.value = link;
  popup.style.display = "flex";
}); 
}
if(closeBtn){
closeBtn.addEventListener("click", () => {
  popup.style.display = "none";
}); 
}

// Copy function (used by both buttons)
function copyWishlistLink(button) {
  linksBox.select();
  document.execCommand("copy");

  const originalHTML = button.innerHTML;
  button.innerText = "Copied!";
  setTimeout(() => (button.innerHTML = originalHTML), 1500);
}

if(linksBox){
// Also copy if user clicks inside input box
linksBox.addEventListener("click", () => {
  linksBox.select();
  document.execCommand("copy");
  copyWishlistLink(copyBtn);
  //setTimeout(() => (copyBtn.innerHTML = '📋 Copy'), 1500);
});
}

// Assign same copy behavior to both buttons
if(copyBtn)
copyBtn.addEventListener("click", () => copyWishlistLink(copyBtn));

if(copyBtn2)
copyBtn2.addEventListener("click", () => copyWishlistLink(copyBtn2));

if(popup){
popup.addEventListener("click", (event) => {
  // Close only if the click was on the background overlay, not inside the popup box
  if (event.target === popup) {
    popup.style.display = "none";
  }
});
}


/*

  
document.addEventListener("DOMContentLoaded", function() {
  const form = document.querySelector("#customer_login");
  if (!form) return;

  form.addEventListener("submit", function(event) {
    const email = form.querySelector("#customer_email").value;
    const password = form.querySelector("#customer_password").value;

    // ⚠️ Do NOT store password anywhere.
    // Instead, immediately use it to request a Storefront API customerAccessToken. 
    localStorage.setItem("cs_em", email);
    localStorage.setItem("cs_ps", password); 

    // Example: call customerAccessTokenCreate mutation
    // createCustomerAccessToken(email, password).then(token => {
    //   localStorage.setItem("customerAccessToken", token);
    // });

    // Let the form submit normally so Shopify logs them in
    // (Don’t preventDefault unless you’re handling login fully in JS)
  });
});







 




var cus_tk = localStorage.getItem("cs_tk");
if(!cus_tk)
{
// now I have customer token, lets do it!!!

 
// Add product
//await Wishlist.add("coralseek-blue-quartz", cus_tk);

// Remove product
//await Wishlist.remove("claude-classic-blue-automatic", cus_tk);

// Get all
//const currentWishlist = await Wishlist.get(cus_tk);
//console.log("Wishlist:", currentWishlist);


}

// --------------------
// Shopify Storefront API Setup
// --------------------
const SHOPIFY_STOREFRONT_API = "https://cainte-com.myshopify.com/api/2025-01/graphql.json";
const SHOPIFY_STOREFRONT_TOKEN = "d3a52784c2f950ad7547d56c26f2b2ee"; // Storefront API token 

async function shopifyFetch(query, variables, customerAccessToken) {
  const res = await fetch(SHOPIFY_STOREFRONT_API, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_TOKEN,
      "Authorization": `Bearer ${customerAccessToken}`
    },
    body: JSON.stringify({ query, variables })
  });
  return res.json();
}

// --------------------
// Wishlist with Tags
// --------------------
const Wishlist = {
  prefix: "wishlist:",

  async get(customerAccessToken) {
    const query = `
      query getCustomerTags($customerAccessToken: String!) {
        customer(customerAccessToken: $customerAccessToken) {
          tags
        }
      }
    `;
    const json = await shopifyFetch(query, { customerAccessToken }, customerAccessToken);
    const tags = json.data?.customer?.tags || [];
    return tags
      .filter(tag => tag.startsWith(this.prefix))
      .map(tag => tag.replace(this.prefix, ""));
  },

async set(items, customerAccessToken) {
  const query = `
    mutation updateCustomerTags($customerAccessToken: String!, $tags: [String!]!) {
      customerUpdate(
        customerAccessToken: $customerAccessToken
        customer: { tags: $tags }
      ) {
        customer { tags }
        userErrors { field message }
      }
    }
  `;

  // prefix all wishlist items
  const wishlistTags = items.map(i => this.prefix + i);

  // First fetch all current tags (to keep non-wishlist ones)
  const allTagsQuery = `
    query getCustomerTags($customerAccessToken: String!) {
      customer(customerAccessToken: $customerAccessToken) {
        tags
      }
    }
  `;
  const current = await shopifyFetch(allTagsQuery, { customerAccessToken }, customerAccessToken);
  const currentTags = current.data?.customer?.tags || [];

  // Keep non-wishlist tags + add new wishlist tags
  const nonWishlistTags = currentTags.filter(t => !t.startsWith(this.prefix));
  const newTags = [...nonWishlistTags, ...wishlistTags];

  const json = await shopifyFetch(
    query,
    { customerAccessToken, tags: newTags },
    customerAccessToken
  );

  console.log("Update response:", JSON.stringify(json, null, 2));
  return json.data?.customerUpdate?.customer?.tags || [];
},


  async add(item, customerAccessToken) {
    let items = await this.get(customerAccessToken);
    if (!items.includes(item)) {
      items.push(item);
      await this.set(items, customerAccessToken);
    }
    return items;
  },

  async remove(item, customerAccessToken) {
    let items = await this.get(customerAccessToken);
    items = items.filter(i => i !== item);
    await this.set(items, customerAccessToken);
    return items;
  }
};

*/